import React from "react";
import Header from "../components/Header";
import PagesHero from "../components/PagesHero";
import ContactSection from "../components/ContactSection";
import FooterSection from "../components/FooterSection";
import FaqSection from '../components/FaqSection';


export default function Contact() {
  return (
    <div>
      <Header />
      <PagesHero page={"contact"} />
      <ContactSection />
      <FaqSection />
      <FooterSection />
    </div>
  );
}
